(function () {
    const CLIP_COLLAPSED = 'is-collapsed';
    const BLOCK_EXPANDED = 'cap-section-block--body-expanded';
    const VISIBLE_PARAS = 4;
  
    function splitContentForA11y(el) {
      var nodes = Array.from(el.childNodes), count = 0, lastBr = true;
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].nodeName === 'BR') { lastBr = true; continue; }
        if (nodes[i].nodeType === Node.TEXT_NODE && nodes[i].textContent.trim() === '') continue;
        if (lastBr || count === 0) { count++; lastBr = false; }
        if (count > VISIBLE_PARAS) {
          var s = i;
          while (s > 0 && (nodes[s - 1].nodeName === 'BR' || (nodes[s - 1].nodeType === Node.TEXT_NODE && nodes[s - 1].textContent.trim() === ''))) s--;
          var span = document.createElement('span');
          nodes.slice(s).forEach(function (n) { span.appendChild(n); });
          el.appendChild(span);
          return span;
        }
      }
      return null;
    }
  
    function initTruncate(root) {
      if (root.dataset.brandAtPerfTruncateInit === '1') {
        return;
      }
      root.dataset.brandAtPerfTruncateInit = '1';
  
      const clip = root.querySelector('.cap-section-body-clip');
      const body = root.querySelector('.cap-section-body');
      const btn = root.querySelector('.cap-section-read-more');
      const block = root.closest('.cap-section-block');
      if (!clip || !body || !btn || !block) {
        return;
      }
  
      const brandName = root.dataset.brandName || '';
      const readMore = root.dataset.readMore || 'Read more';
      const readLess = root.dataset.readLess || 'Read less';
      const panel = root.closest('.accordion-panel');
  
      let resizeTimer = null;
      /** @type {number | null} */
      let raf = null;
      let zeroHeightRetries = 0;
  
      var hiddenSpan = splitContentForA11y(body.querySelector('p') || body);
  
      function setClipAccessibility(hidden) {
        if (!hiddenSpan) return;
        hiddenSpan.inert = hidden;
        if (hidden) hiddenSpan.setAttribute('aria-hidden', 'true');
        else hiddenSpan.removeAttribute('aria-hidden');
      }
  
      function scheduleMeasure() {
        if (raf !== null) {
          cancelAnimationFrame(raf);
        }
        raf = requestAnimationFrame(() => {
          raf = requestAnimationFrame(() => {
            raf = null;
            void runMeasureAfterFonts();
          });
        });
      }
  
      async function runMeasureAfterFonts() {
        try {
          if (document.fonts?.ready) {
            await document.fonts.ready;
          }
        } catch {
          // Still measure if font loading fails
        }
        measure();
      }
  
      /**
       * @param {boolean} expanded
       */
      function setExpandedUi(expanded) {
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) {
          block.classList.add(BLOCK_EXPANDED);
          clip.classList.remove(CLIP_COLLAPSED);
          setClipAccessibility(false);
          block.style.height = 'auto';
          block.style.maxHeight = 'none';
          btn.textContent = readLess;
          if (brandName) {
            btn.setAttribute('aria-label', `${readLess} about ${brandName}`);
          } else {
            btn.removeAttribute('aria-label');
          }
        } else {
          block.classList.remove(BLOCK_EXPANDED);
          clip.classList.add(CLIP_COLLAPSED);
          setClipAccessibility(true);
          block.style.height = '';
          block.style.maxHeight = '';
          btn.textContent = readMore;
          if (brandName) {
            btn.setAttribute('aria-label', `${readMore} about ${brandName}`);
          } else {
            btn.removeAttribute('aria-label');
          }
        }
      }
  
      function measure() {
        if (panel?.hidden) {
          return;
        }
  
        const userExpanded = block.classList.contains(BLOCK_EXPANDED);
  
        block.classList.remove(BLOCK_EXPANDED);
        clip.classList.add(CLIP_COLLAPSED);
  
        requestAnimationFrame(() => {
          if (clip.clientHeight < 1 && body.scrollHeight > 0) {
            clip.classList.remove(CLIP_COLLAPSED);
            if (userExpanded) {
              block.classList.add(BLOCK_EXPANDED);
            }
            if (zeroHeightRetries < 8) {
              zeroHeightRetries += 1;
              setTimeout(scheduleMeasure, 100);
            }
            return;
          }
  
          zeroHeightRetries = 0;
  
          const overflows = body.scrollHeight > clip.clientHeight + 2;
  
          if (!overflows) {
            clip.classList.remove(CLIP_COLLAPSED);
            setClipAccessibility(false);
            block.classList.remove(BLOCK_EXPANDED);
            block.style.height = '';
            block.style.maxHeight = '';
            btn.hidden = true;
            btn.removeAttribute('aria-label');
            return;
          }
  
          btn.hidden = false;
          setExpandedUi(userExpanded);
        });
      }
  
      function onButtonClick() {
        setExpandedUi(!block.classList.contains(BLOCK_EXPANDED));
      }
  
      function onWindowResize() {
        if (resizeTimer !== null) {
          clearTimeout(resizeTimer);
        }
        resizeTimer = window.setTimeout(() => {
          resizeTimer = null;
          scheduleMeasure();
        }, 150);
      }
  
      /**
       * Runs after `accessible-accordion` updates `hidden` / aria (toggle uses click or keydown).
       */
      function onAccordionMayHaveToggled(event) {
        const target = event.target;
        if (!(target instanceof Element)) {
          return;
        }
        if (!target.closest('.accordion-trigger')) {
          return;
        }
        requestAnimationFrame(() => {
          scheduleMeasure();
        });
      }
  
      btn.addEventListener('click', onButtonClick);
  
      for (const img of body.querySelectorAll('img')) {
        if (img.complete) {
          continue;
        }
        img.addEventListener('load', scheduleMeasure);
        img.addEventListener('error', scheduleMeasure);
      }
  
      const accordion = panel?.closest('accessible-accordion');
      if (accordion) {
        accordion.addEventListener('click', onAccordionMayHaveToggled);
        accordion.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }
          onAccordionMayHaveToggled(event);
        });
        if (!panel.hidden) {
          scheduleMeasure();
        }
      } else {
        scheduleMeasure();
      }
  
      window.addEventListener('resize', onWindowResize);
      window.addEventListener('orientationchange', onWindowResize);
    }
  
    function boot() {
      for (const root of document.querySelectorAll('[data-brand-at-perf-truncate]')) {
        if (root instanceof HTMLElement) {
          initTruncate(root);
        }
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();